import { HealingOutlined } from "@mui/icons-material";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";

// ---------------------------------------------------------------------------
// Shared option lists
// ---------------------------------------------------------------------------
export const ATTENDER_TYPE_OPTIONS = [
  { value: "1", label: "Known Attender / தெரிந்த அட்டெண்டர்" },
  { value: "2", label: "No Attender / அட்டெண்டர் இல்லை" },
];

// First attender relation options
export const FIRST_RELATION_OPTIONS = [
  { value: "1", label: "Spouse / வாழ்க்கைத் துணை" },
  { value: "2", label: "Parent / பெற்றோர்" },
  { value: "3", label: "Child / குழந்தை" },
  { value: "4", label: "Sibling / உடன்பிறப்பு" },
  { value: "5", label: "Friend / நண்பர்" },
  { value: "6", label: "Other / வேறு" },
];

// Second attender relation options (slightly different Tamil labels)
export const SECOND_RELATION_OPTIONS = [
  { value: "1", label: "Spouse/ வாழ்க்கைத் துணை" },
  { value: "2", label: "Parent / தந்தை/தாய்" },
  { value: "3", label: "Child / குழந்தை" },
  { value: "4", label: "Sibling  / உடன்பிறப்பு" },
  { value: "5", label: "Friend / நண்பன்" },
  { value: "6", label: "Other / மற்றவர்" },
];

// ---------------------------------------------------------------------------
// Phone validation rule (shared)
// ---------------------------------------------------------------------------
const PHONE_RULES = {
  required: "Phone number is required",
  pattern: {
    value: /^(6|7|8|9)\d{9}$/,
    message: "Please enter a valid 10-digit phone number",
  },
  maxLength: {
    value: 10,
    message: "Phone number should be 10 digits",
  },
};

// ---------------------------------------------------------------------------
// Static field definitions
// ---------------------------------------------------------------------------
export const ATTENDER_TYPE_FIELD = [
  {
    name: "attender_type",
    label: "Attender Type / வருகையாளர் வகை",
    placeholder: "Select attender type",
    type: "select",
    tabIndex: 7,
    defaultValues: "1",
    options: ATTENDER_TYPE_OPTIONS,
    rules: { required: "Attender type is required" },
    startIcon: <HealingOutlined />,
  },
];

export const ATTENDER_NUMBER_FIELD = [
  {
    name: "no_of_attenders",
    label: "Number of Attenders / வருகையாளர்களின் எண்ணிக்கை ",
    placeholder: "Enter number of attenders (1 or 2)",
    type: "text",
    tabIndex: 8,
    defaultValues: "1",
    rules: {
      required: "Number of attenders is required",
      pattern: {
        value: /^[1-2]$/,
        message: "Only 1 or 2 attenders are allowed",
      },
    },
    startIcon: <PersonIcon />,
  },
];

export const FIRST_ATTENDER_FIELDS = [
  {
    name: "attender_name",
    label: "Attender Name / வருகையாளர் பெயர்",
    placeholder: "Enter attender name",
    type: "text",
    tabIndex: 9,
    rules: { required: "Attender name is required" },
    startIcon: <PersonIcon />,
  },
  {
    name: "attender_relation",
    label: "Relation with Patient / நோயாளியுடனான உறவு",
    placeholder: "Enter relation",
    type: "select",
    tabIndex: 10,
    options: FIRST_RELATION_OPTIONS,
    rules: { required: "Relation is required" },
    startIcon: <FamilyRestroomIcon />,
  },
  {
    name: "attender_address",
    label: "Address / முகவரி",
    placeholder: "Enter address",
    type: "text",
    tabIndex: 11,
    multipleLine: true,
    rules: { required: "Address is required" },
    startIcon: <HomeIcon />,
  },
  {
    name: "attender_phone",
    label: "Phone Number /  தொலைபேசி எண்",
    placeholder: "Enter phone number",
    type: "text",
    tabIndex: 12,
    maxLength: 10,
    showCharCount: false,
    rules: PHONE_RULES,
    startIcon: <PhoneIcon />,
  },
];

export const SECOND_ATTENDER_FIELDS = [
  {
    name: "attender_name_2",
    label: "Second Attender Name / இரண்டாவது வருகையாளர் பெயர்",
    placeholder: "Enter attender name",
    type: "text",
    tabIndex: 13,
    rules: { required: "Second attender name is required" },
    startIcon: <PersonIcon />,
  },
  {
    name: "attender_relation_2",
    label: "Relation with Patient / நோயாளியுடனான உறவு",
    placeholder: "Enter relation",
    type: "select",
    tabIndex: 14,
    options: SECOND_RELATION_OPTIONS,
    rules: { required: "Relation is required" },
    startIcon: <FamilyRestroomIcon />,
  },
  {
    name: "attender_address_2",
    label: "Address /  நோயாளியின் பெயர்",
    placeholder: "Enter address",
    type: "text",
    tabIndex: 15,
    multipleLine: true,
    rules: { required: "Address is required" },
    startIcon: <HomeIcon />,
  },
  {
    name: "attender_phone_2",
    label: "Phone Number /  தொலைபேசி எண்",
    placeholder: "Enter phone number",
    type: "text",
    tabIndex: 16,
    maxLength: 10,
    showCharCount: false,
    rules: {
      required: "Phone number is required",
      pattern: {
        value: /^(6|7|8|9)\d{9}$/,
        message: "Please enter a valid 10-digit phone number",
      },
    },
    startIcon: <PhoneIcon />,
  },
];
